import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Advantage' })((theme) => ({
    root: {
        display: 'flex',
        padding: '64px 40px 40px 40px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 32,
        flex: '1 0 0',
        borderRadius: 24,
        background: 'rgba(255, 255, 255, 0.03)',
        backdropFilter: 'blur(40px)',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: '40px 24px'
        }
    },
    icon: {
        lineHeight: 0,
        width: 56,
        height: 56,
        '& > svg': {
            width: '100%',
            height: '100%'
        }
    }
}));
